import EquipSplashScreen from "@/ui/components/splashScreen/EquipSplashScreen";

const MyEquipCallback = () => {
  // Auth0 Universal Login Page redirects to /myequip after a successful login
  // RootNavigator however handles useWebAuthFlow, leaving this as just a splash screen
  return <EquipSplashScreen />;
};

export default MyEquipCallback;
